
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const RightPanel = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <polygon points="13.4 18.6 12.4 17.6 17.4 12.5 12.4 7.4 13.4 6.4 19.6 12.5 13.4 18.6"></polygon>
          <polygon points="7 18.6 6 17.6 11 12.5 6 7.4 7 6.4 13.2 12.5 7 18.6"></polygon>
        </g>
      </g>
    </IconBase>);
};

RightPanel.defaultProps = {
  title: 'Right Panel',
};

export default RightPanel;
